<template>
    <div>
      <el-row>
          <el-col :lg="21" :offset="1">
           <el-row>
               <el-col :lg="12">
               品牌: <el-tag type="info" effect="dark">{{this.memberPointN.brand_id == 1 ? 'N牌':'S牌'}}</el-tag>
               </el-col>
               <el-col :lg="12"></el-col>
           </el-row>
           <el-row style="margin-top:20px;">
               <el-col :lg="24">
               系統預設: 會員等級白金  <el-tag type="info" effect="dark">訂單金額</el-tag> / (<el-tag type="info" effect="dark">門檻: NT$200</el-tag> X <el-tag type="info" effect="dark">倍率: 2</el-tag>
                會員等級尊爵  <el-tag type="info" effect="dark">訂單金額</el-tag> / (<el-tag type="info" effect="dark">門檻: NT$200</el-tag> X <el-tag type="info" effect="dark">倍率: 3</el-tag>
                )
               
               </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
              <el-col :lg="24">
              活動設定:
              <el-tag type="success" effect="dark">
                  區間:    {{this.memberPointN.set_start_day}}- {{this.memberPointN.set_end_day}} 星期: {{this.memberPointN.set_week_day}} 
                  公式: 訂單金額 / (門檻NT${{this.memberPointN.amount}} X 倍率: 會員等級: 白金:{{this.memberPointN.set_point_multiple_level1}}倍/尊爵:{{this.memberPointN.set_point_multiple_level2}}倍 )
              </el-tag>
              
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="12">
               <el-button type="primary" @click="diaNVisable = true" >修改</el-button>
               <el-dialog
                     title="修改"
                     :visible.sync="diaNVisable"
                     center
                     width="50%"
                     >
                     <div class="dialog">
                     <el-form :rules="rule" :model="updateFormN" ref="updateFormN" label-width="120px">
                         <el-form-item label="日期區間:" prop="date">
                         <el-date-picker type="daterange" v-model="updateFormN.date" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期" >
                         </el-date-picker>
                         
                         </el-form-item>
                         <el-form-item label="星期:" >
                             <el-select v-model="updateFormN.setWeekDay" placeholder="">
                                 <el-option v-for="item in Options"
                                     :key="item.value"
                                     :label="item.label"
                                     :value="item.value">
                                 </el-option>
                             </el-select>
                             
                         </el-form-item>
                        
                          <el-form-item label="門檻:" prop="amount">
                                 <el-input type="number" v-model.number="updateFormN.amount" placeholder="NT$" style="width:50%;"></el-input>
                                 
                             </el-form-item>
                             <el-form-item label="會員等級白金倍率:" prop="set_point_multiple_Level1">
                                 <el-input type="number" v-model.number="updateFormN.setPointMultple_Level1" placeholder="" style="width:50%;"></el-input>
                                 
                             </el-form-item>
                             <el-form-item label="會員等級尊爵倍率:" prop="set_point_multiple_Level2">
                                 <el-input type="number" v-model.number="updateFormN.setPointMultple_Level2" placeholder="" style="width:50%;"></el-input>
                                 
                             </el-form-item>
                             
                         
                         
                      
                     </el-form>
                     
                    
                         <el-button @click=" diaNVisable = false">取 消</el-button>
                         <el-button type="primary" @click="updateMemberPointN('updateFormN')" >確 定</el-button>
                     
                     </div>
                 </el-dialog>
              </el-col>
              <el-col :lg="12"></el-col>
          </el-row>
          
          
           
           
          </el-col>
      </el-row>
      <hr />
      <el-row>
          <el-col :lg="21" :offset="1">
           <el-row>
               <el-col :lg="12">
               品牌: <el-tag type="info" effect="dark">{{this.memberPointS.brand_id == 1 ? 'N牌':'S牌'}}</el-tag>
               </el-col>
               <el-col :lg="12"></el-col>
           </el-row>
           <el-row style="margin-top:20px;">
               <el-col :lg="24">
               系統預設: 會員等級芙蓉  <el-tag type="info" effect="dark">訂單金額</el-tag> / (<el-tag type="info" effect="dark">門檻: NT$200</el-tag> X <el-tag type="info" effect="dark">倍率: 2</el-tag>
                會員等級金鑽  <el-tag type="info" effect="dark">訂單金額</el-tag> / (<el-tag type="info" effect="dark">門檻: NT$200</el-tag> X <el-tag type="info" effect="dark">倍率: 3</el-tag>
                )
               
               </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
              <el-col :lg="24">
              活動設定:
              <el-tag type="success" effect="dark">
                  區間:    {{this.memberPointS.set_start_day}}- {{this.memberPointS.set_end_day}} 星期: {{this.memberPointS.set_week_day}} 
                  公式: 訂單金額 / (門檻NT${{this.memberPointS.amount}} X 倍率: 會員等級: 芙蓉{{this.memberPointS.set_point_multiple_level1}}倍/金鑽:{{this.memberPointS.set_point_multiple_level2}}倍 )
              </el-tag>
              
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="12">
               <el-button type="primary" @click="diaSVisable = true" >修改</el-button>
                 <el-dialog
                     title="修改"
                     :visible.sync="diaSVisable"
                     center
                     width="50%"
                     >
                     <div class="dialog">
                     <el-form :rules="rule" :model="updateFormS" ref="updateFormS" label-width="120px">
                         <el-form-item label="日期區間:" prop="date">
                         <el-date-picker type="daterange" v-model="updateFormS.date" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期" >
                         </el-date-picker>
                         
                         </el-form-item>
                         <el-form-item label="星期:" prop="setWeekDay">
                             <el-select v-model="updateFormS.setWeekDay" placeholder="">
                                 <el-option v-for="item in Options"
                                     :key="item.value"
                                     :label="item.label"
                                     :value="item.value">
                                 </el-option>
                             </el-select>
                             
                         </el-form-item>
                        
                          <el-form-item label="門檻:" prop="amount">
                                 <el-input type="number" v-model.number="updateFormS.amount" placeholder="NT$" style="width:50%;"></el-input>
                                 
                             </el-form-item>
                             <el-form-item label="會員等級芙蓉倍率:" prop="setPointMultple_Level1">
                                 <el-input type="number" v-model.number="updateFormS.setPointMultple_Level1" placeholder="" style="width:50%;"></el-input>
                                 
                             </el-form-item>
                             <el-form-item label="會員等級金鑽倍率:" prop="setPointMultple_Level2">
                                 <el-input type="number" v-model.number="updateFormS.setPointMultple_Level2" placeholder="" style="width:50%;"></el-input>
                                 
                             </el-form-item>
                           
                     
                     
                   
                         <el-button @click=" diaSVisable = false">取 消</el-button>
                         <el-button type="primary" @click="updateMemberPointS('updateFormS')" >確 定</el-button>
                    
                     </el-form>
                     </div>
                 </el-dialog>
                 
              </el-col>
              <el-col :lg="12"></el-col>
          </el-row>
          
          
          </el-col>
      </el-row>
      
      
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
    export default {
        name: 'set',
        data() {
            return {
             memberPointN: {},
             memberPointS: {},
             updateFormN: {
                 date: [],
                 setWeekDay: '',
                 amount: 0,
                 setPointMultple_Level1: 0,
                 setPointMultple_Level2: 0
             },
             updateFormS: {
                     date: [],
                 setWeekDay: '',
                 amount: 0,
                 setPointMultple_Level1: 0,
                 setPointMultple_Level2: 0
             },
             diaNVisable: false,   
             diaSVisable: false,
             startDay: '',
             endDay: '',
             Options: [
                 {label: '星期一', value: '星期一'},
                 {label: '星期二', value: '星期二'},
                 {label: '星期三', value: '星期三'},
                 {label: '星期四', value: '星期四'},
                 {label: '星期五', value: '星期五'},
                 {label: '星期六', value: '星期六'},
                 {label: '星期日', value: '星期日'}
             ],
             rule: {
                 date: [
                     {required: true, message: '請填入日期區間', trigger: 'blur'}
                 ],
                 amount: [
                     {required: true, message: '請填入門檻金額' }
                 ],
                 setPointMultple: [
                     { required: true, message: '請填入點數倍數'}
                 ]
             }
            }
        },
        computed: mapGetters(["getMemberPointN", "getMemberPointS", "getMemberPointError", "getMemberPointMsg"]),
        methods: {
            ...mapActions(["fetchMemberPointN", "fetchMemberPointS", "updateMemberPoint"]),
            async fetchMemberPointN(){
                const data = {brand_id: 1}
               await this.$store.dispatch('fetchMemberPointN', data)
               this.memberPointN = this.getMemberPointN
            },
            async fetchMemberPointS(){
                const data = {brand_id: 2}
               await this.$store.dispatch('fetchMemberPointS', data)
               this.memberPointS = this.getMemberPointS
            },
            async updateMemberPointN(formName){
                this.startDay = moment(this.updateFormN.date[0]).format('YYYY-MM-DD')
                this.endDay = moment(this.updateFormN.date[1]).format('YYYY-MM-DD')
                const data = {
                    _key: this.getMemberPointN._key,
                    brand_id: 1,
                    set_start_day: this.startDay,
                    set_end_day: this.endDay,
                    set_week_day: this.updateFormN.setWeekDay,
                    amount: this.updateFormN.amount,
                    set_point_multiple_level1: this.updateFormN.setPointMultple_Level1,
                    set_point_multiple_level2: this.updateFormN.setPointMultple_Level2
                }
                await this.$store.dispatch('updateMemberPoint', data)
                if(this.getMemberPointError != true){
                    this.$notify({
                        title: '成功',
                        message: '修改點數規則成功',
                        type: 'success',
                        duration: '4500',
                        position: 'top-right'
                    });
                    this.$refs[formName].resetFields()
                    this.diaNVisable = false
                    
                }else {
                    this.$notify({
                        title: '失敗',
                        message: this.getMemberPointMsg,
                        type: 'info',
                        duration: '4500',
                        position: 'top-right'
                    });
                    
                }
               
            },
            async updateMemberPointS(formName){
                this.startDay = moment(this.updateFormS.date[0]).format('YYYY-MM-DD')
                this.endDay = moment(this.updateFormS.date[1]).format('YYYY-MM-DD')
                const data = {
                    _key: this.getMemberPointS._key,
                    brand_id: 2,
                    set_start_day: this.startDay,
                    set_end_day: this.endDay,
                    set_week_day: this.updateFormS.setWeekDay,
                    amount: this.updateFormS.amount,
                    set_point_multiple_level1: this.updateFormS.setPointMultple_Level1,
                    set_point_multiple_level2: this.updateFormS.setPointMultple_Level2
                }
                await this.$store.dispatch('updateMemberPoint', data)
                if(this.getMemberPointError != true){
                    this.$notify({
                        title: '成功',
                        message: '修改點數規則成功',
                        type: 'success',
                        duration: '4500',
                        position: 'top-right'
                    });
                    this.$refs[formName].resetFields()
                    this.diaSVisable = false
                    
                }else {
                    this.$notify({
                        title: '失敗',
                        message: this.getMemberPointMsg,
                        type: 'info',
                        duration: '4500',
                        position: 'top-right'
                    });
                    
                }
               
            }
        },
        created() {
            this.fetchMemberPointN()
            this.fetchMemberPointS()
        },
    }
</script>
<style lang="scss" scoped>
dialog {
    height: 60vh;
    overflow: auto;
}
</style>